import { render, staticRenderFns } from "./NotificationsWidget.vue?vue&type=template&id=212c3144&"
import script from "./NotificationsWidget.vue?vue&type=script&lang=js&"
export * from "./NotificationsWidget.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsWidget.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports